import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { CONFIG, CONFIG_API_BE, URL_AKM } from "../../../../../config";
import { cekCookies } from "../../../../../actions";
import history from "../../../../../history";
import __ from "lodash";
import Loader from "../../../../Loader";
import { Row, Col, Alert, Modal } from "react-bootstrap";
import LoaderModal from "../../../../modal/LoaderModal";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";
import accountManagement from "../../../../../apis/accountManagement";
import eduprimeApi from "../../../../../apis/eduprimeApi";
import akmApi from "../../../../../apis/akmApi";
import Select from "react-select";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Checkbox from "@material-ui/core/Checkbox";

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Typography, Collapse, Box, Button, ButtonGroup } from "@material-ui/core";
import PaginationTable from "../../masterDropDown/PaginationTable";
import PaginationData from "../../../../../entity/PaginationData";
import ArraySoal from "../../../../../entity/ArraySoal";
import VisibilityRoundedIcon from "@material-ui/icons/VisibilityRounded";
import GetAppIcon from "@material-ui/icons/GetApp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

import DropdownKurikulum from "../../masterDropDown/DropdownKurikulum";
import DropdownSubTipeToo from "../../masterDropDown/DropdownSubTipeToo";

import ListProfil from "./ListProfil";
import MgtSoal from "./MgtSoal";
import ModalDublicatProfil from "./ModalDublicatProfil";

import respProfilAgcu from "./respProfilAgcu";
import { data } from "jquery";

class MgtProfil extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      resMessage: "",
      alertShow: false,
      isFetching: false,
      isMgtSoal: false,
      isOpenList: false,
      isHapusProfil: false,
      isHapusMapel: false,
      isOpenDublicat: false,
      hapusData: {},
      openModal: false,
      namaProfil: null,
      tipeButton: "Simpan",
      newProfil: {},
      profilSelected: {},
      listKelas: [],
      listKelasGroup: [],
      listAgcuNon: [],
      subProfil: {},
      listProfil: [],
      paginationData: PaginationData,
      nonAkademik: [],
      listKurikulum: [],
    };
  }

  async componentDidMount() {
    console.clear();
    this.setState({ isFetching: true });
    await this.props.cekCookies();
    if (!__.isEmpty(this.props.account)) {
      if (this.props.location.pathname === "/mgttoo") {
        this.setState({ kodeTipeCbt: "TOO", kodeSubTipeCbt: "TRYOUT" });
        this.setState((prevState) => {
          let newProfil = Object.assign({}, prevState.newProfil);
          newProfil["kodeSubTipeCbt"] = "TRYOUT";
          newProfil["kodeTipeCbt"] = "TOO";
          return { newProfil };
        });
      } else if (this.props.location.pathname === "/mgtsbmptn") {
        // this.fetchProfilAgcuNon();
        this.setState({ kodeTipeCbt: "TOO", kodeSubTipeCbt: "SBMPTN" });
        this.setState((prevState) => {
          let newProfil = Object.assign({}, prevState.newProfil);
          newProfil["kodeSubTipeCbt"] = "SBMPTN";
          newProfil["kodeTipeCbt"] = "TOO";
          return { newProfil };
        });
      } else if (this.props.location.pathname === "/mgtagcu") {
        // this.fetchProfilAgcuNon();
        this.setState({ kodeTipeCbt: "AGCU", kodeSubTipeCbt: "AGCU" });
        this.setState((prevState) => {
          let newProfil = Object.assign({}, prevState.newProfil);
          newProfil["kodeSubTipeCbt"] = "AGCU";
          newProfil["kodeTipeCbt"] = "AGCU";
          return { newProfil };
        });
      } else if (this.props.location.pathname === "/mgtpeminatan") {
        // this.fetchProfilAgcuNon();
        this.setState({ kodeTipeCbt: "PEMINATAN", kodeSubTipeCbt: "PEMINATAN" });
        this.setState((prevState) => {
          let newProfil = Object.assign({}, prevState.newProfil);
          newProfil["kodeSubTipeCbt"] = "PEMINATAN";
          newProfil["kodeTipeCbt"] = "PEMINATAN";
          return { newProfil };
        });
      } else if (this.props.location.pathname === "/mgtpemetaan") {
        // this.fetchProfilAgcuNon();
        this.setState({ kodeTipeCbt: "PEMETAAN", kodeSubTipeCbt: "PEMETAAN" });
        this.setState((prevState) => {
          let newProfil = Object.assign({}, prevState.newProfil);
          newProfil["kodeSubTipeCbt"] = "PEMETAAN";
          newProfil["kodeTipeCbt"] = "PEMETAAN";
          return { newProfil };
        });
      } else if (this.props.location.pathname === "/mgtpemetaan2") {
        // this.fetchProfilAgcuNon();
        this.setState({ kodeTipeCbt: "PEMETAAN2", kodeSubTipeCbt: "PEMETAAN2" });
        this.setState((prevState) => {
          let newProfil = Object.assign({}, prevState.newProfil);
          newProfil["kodeSubTipeCbt"] = "PEMETAAN2";
          newProfil["kodeTipeCbt"] = "PEMETAAN2";
          return { newProfil };
        });
      } else if (this.props.location.pathname === "/mgtpemetaan3") {
        // this.fetchProfilAgcuNon();
        this.setState({ kodeTipeCbt: "PEMETAAN3", kodeSubTipeCbt: "PEMETAAN3" });
        this.setState((prevState) => {
          let newProfil = Object.assign({}, prevState.newProfil);
          newProfil["kodeSubTipeCbt"] = "PEMETAAN3";
          newProfil["kodeTipeCbt"] = "PEMETAAN3";
          return { newProfil };
        });
      } else if (this.props.location.pathname === "/mgtensa") {
        // this.fetchProfilAgcuNon();
        this.setState({ kodeTipeCbt: "ENSA", kodeSubTipeCbt: "ENSA" });
        this.setState((prevState) => {
          let newProfil = Object.assign({}, prevState.newProfil);
          newProfil["kodeSubTipeCbt"] = "ENSA";
          newProfil["kodeTipeCbt"] = "ENSA";
          return { newProfil };
        });
      }

      // FETCH KURIKULUM
      await akmApi
        .get(URL_AKM.KURIKULUM_GET_ALL)
        .then((data) => {
          this.setState({ listKurikulum: data.data.data });
        })
        .catch((err) => {});

      // FETCH KELAS
      if (__.isEmpty(this.state.listKelas)) {
        const respons = await akmApi.get(URL_AKM.KELAS_ALL, {});

        if (respons.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
          const dataKelas = { value: "", label: "Pilih Kelas...", id: "idKelas", selected: "selected" };
          this.state.listKelas.push(dataKelas);
          respons.data.data.map((val, i) => {
            const dataKelas = { value: val.idKelas, label: val.namaKelas, id: "idKelas" };
            this.state.listKelas.push(dataKelas);
          });
        }
      }

      // FETCH KELAS group
      if (__.isEmpty(this.state.listKelasGroup)) {
        const respons = await akmApi.get(URL_AKM.KELAS_GROUP_ALL, {});

        if (respons.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
          const dataKelas = { value: "", label: "Pilih Kelas Group...", id: "idKelasGroup", selected: "selected" };
          this.state.listKelasGroup.push(dataKelas);
          respons.data.data.map((val, i) => {
            const dataKelas = { value: val.idKelasGroup, label: val.namaKelasGroup, id: "idKelasGroup" };
            this.state.listKelasGroup.push(dataKelas);
          });
        }
      }

      this.fetchProfil(this.state.namaProfil);
    }
    this.setState({ isFetching: false });
  }

  async fetchProfilAgcuNon() {
    if (__.isEmpty(this.state.listAgcuNon)) {
      this.setState({ isFetching: true });
      const respons = await akmApi.get(URL_AKM.PROFIL_AGCU_NON, {});

      if (respons.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
        const data = { value: "", label: "Pilih Profil...", id: "idProfilAgcuNonAkademik", selected: "selected" };
        this.state.listAgcuNon.push(data);
        respons.data.data.map((val, i) => {
          const data = { value: val.idProfilAgcuNonAkademik, label: val.namaProfilAgcu, id: "idProfilAgcuNonAkademik" };
          this.state.listAgcuNon.push(data);
        });
      }
    }
  }

  handleChangeSelect = async (e) => {
    const name = e.id;
    const id = e.value;

    if (__.isArray(e)) {
      this.setState({ listProfilAgcuTerpilih: [] });
      e.map((val, i) =>
        this.setState((prevState) => {
          let newProfil = Object.assign({}, prevState.newProfil);
          newProfil["listProfilAgcuTerpilih"] = e;
          return { newProfil };
        })
      );
    } else {
      this.setState((prevState) => {
        let newProfil = Object.assign({}, prevState.newProfil);
        newProfil[name] = id;
        return { newProfil };
      });
    }

    if (name == "idKelas") {
      this.setState((prevState) => {
        let newProfil = Object.assign({}, prevState.newProfil);
        newProfil.idKelasGroup = null;
        return { newProfil };
      });
    } else if (name == "idKelasGroup") {
      this.setState((prevState) => {
        let newProfil = Object.assign({}, prevState.newProfil);
        newProfil.idKelas = null;
        return { newProfil };
      });
    }
  };

  changePageMgtSoal = (profil) => {
    console.log(profil);
    // cari index react select
    if (profil.idKelasGroup != null) {
      this.state.listKelasGroup.map((val, i) => {
        val.value === profil.idKelasGroup && this.setState({ idKelasGroup: i });
      });
    }
    if (profil.idKelas != null) {
      this.state.listKelasGroup.map((val, i) => {
        val.value === profil.idKelas && this.setState({ idKelas: i });
      });
    }

    this.setState({ isMgtSoal: false, newProfil: profil, openModal: true });
  };

  changeMgtProfil = (profil) => {
    // cari index react select
    if (profil.idKelasGroup != null) {
      this.state.listKelasGroup.map((val, i) => {
        val.value === profil.idKelasGroup && this.setState({ idKelasGroup: i });
      });
    }
    if (profil.idKelas != null) {
      this.state.listKelas.map((val, i) => {
        val.value === profil.idKelas && this.setState({ idKelas: i });
      });
    }
    profil["namaKelas"] = profil.namaProfil.split("~")[1];
    profil["namaProfil"] = profil.namaProfil.split("~")[0];

    this.setState({ isMgtSoal: false, newProfil: profil, openModal: true, tipeButton: "Update" });
  };

  changeIsFetch = (status) => {
    this.setState({ isFetching: status });
  };

  changeMgtSoal = (status, profil, mapel) => {
    this.fetchProfil(this.state.namaProfil);
    this.setState({ isMgtSoal: status, newProfil: profil, subProfil: mapel });
  };

  handleRefresh = () => {
    this.fetchProfil(this.state.namaProfil);
  };

  componentDidUpdate() {
    // console.clear();
    console.log(this.state);
  }

  render() {
    const { isFetching, newProfil, isMgtSoal, profilSelected, kodeSubTipeCbt, isOpenDublicat } = this.state;
    return (
      <div className="wrapper">
        <LoaderModal isFetching={isFetching} />
        <Sidebar account={this.props.account} />
        <div id="content" style={{ paddingBottom: "50px" }}>
          <Navbar title={"Manajement Profil " + kodeSubTipeCbt} />
          {this.loadAlert()}
          {this.loadModalMgt()}
          {this.confirmDialog()}
          {!isMgtSoal && (
            <>
              <Row>
                <Col sm={9}>
                  <button className="btn btn-outline-primary" title={"Tambah Profil " + kodeSubTipeCbt} onClick={() => this.setState({ openModal: true })}>
                    <li className="fa fa-plus"> Profil</li>
                  </button>
                </Col>
                <Col style={{ "text-align": "right" }} sm={3}>
                  <input type="text" className="form-control" name="namaProfil" id="namaProfil" onChange={this.handleOnChangeList} />
                </Col>
              </Row>
              <Row>
                <Col>{this.state.isSearch && <Loader />} </Col>
              </Row>
              <Row>
                <Col>
                  {this.renderListProfil()}
                  {/* <ListProfil changeMgtProfil ={this.changeMgtProfil}
                                                changeMgtSoal ={this.changeMgtSoal}
                                                kodeSubTipeCbt = {kodeSubTipeCbt}
                                                detail = {this.state}
                                                fetch = {isFetching}
                                                listProfil = {listProfil}
                                    /> */}
                </Col>
              </Row>
            </>
          )}
          {isMgtSoal && <MgtSoal changeMgtSoal={this.changeMgtSoal} detail={this.state} />}
        </div>
      </div>
    );
  }

  handleOnChange = async (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState((prevState) => {
      let newProfil = Object.assign({}, prevState.newProfil);
      newProfil[name] = value;
      return { newProfil };
    });
    if (name === "kodeTipeCbt") {
      if (value === "PEMETAAN2") {
        this.setState((prevState) => {
          let newProfil = Object.assign({}, prevState.newProfil);
          newProfil["kodeSubTipeCbt"] = value;
          return { newProfil };
        });
      }
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ isFetching: true, openModal: false });
    const response = await akmApi.post(URL_AKM.CBT_PROFIL_POST, this.state.newProfil).catch(function (error) {
      this.setState({ error });
    });

    if (response.data.errorSchema.errorCode == URL_AKM.SUCCESS_ERROR_CODE) {
      this.fetchProfil(this.state.namaProfil);
    }

    this.setState({ isFetching: false, alertShow: true, keterangan: response.data.errorSchema.errorMessage, newProfil: {}, idKelas: null, idKelasGroup: null });
  };

  loadModalMgt() {
    const { newProfil, tipeButton, listKelas, listKelasGroup, listAgcuNon, listKurikulum } = this.state;
    return (
      <Modal
        show={this.state.openModal}
        onHide={() => this.setState({ openModal: false, newProfil: {}, idKelas: null, idKelasGroup: null })}
        aria-labelledby="example-custom-modal-styling-title"
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Profil _{newProfil.kodeSubTipeCbt}_ </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.state.isSearch && <Loader />}
          <form onSubmit={this.handleSubmit}>
            <Row>
              <Col>
                <div className="form-group">
                  <label>Nama Profil</label>

                  <input
                    type="text"
                    className="form-control"
                    name="namaProfil"
                    value={!__.isEmpty(newProfil.namaProfil) ? newProfil.namaProfil.split("~")[0] : newProfil.namaProfil}
                    onChange={this.handleOnChange}
                    placeholder="Nama Profil CBT"
                    title="Nama Profil CBT"
                    required
                    autoComplete="off"
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <div className="form-group">
                  <label>Kurikulum</label>
                  <select className="form-control" name="idKurikulum" value={newProfil.idKurikulum} onChange={this.handleOnChange}>
                    <option value="" selected disabled>
                      Pilih Kurikulum
                    </option>
                    <DropdownKurikulum listKurikulum={listKurikulum} />
                  </select>
                </div>
              </Col>
              <Col sm={6}>
                <div className="form-group">
                  <label>Kode Sub Tipe</label>
                  <select className="form-control" name="kodeTipeCbt" value={newProfil.kodeTipeCbt} onChange={this.handleOnChange} disabled>
                    <option value="" selected disabled>
                      Pilih Sub Tipe
                    </option>
                    <DropdownSubTipeToo />
                  </select>
                </div>
              </Col>
            </Row>
            <Row>
              <Col style={{ "text-align-last": "center" }}>Pilih Kelas / Kelas Group</Col>
            </Row>
            <Row>
              <Col sm={6}>
                <div className="form-group">
                  {}
                  <Fragment>
                    {newProfil.idKelas === null ? (
                      <>
                        <Select options={listKelas} onChange={this.handleChangeSelect} placeholder="Pilih Kelas..." value="" />
                        <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value="" />
                      </>
                    ) : (
                      <>
                        <Select options={listKelas} onChange={this.handleChangeSelect} defaultValue={listKelas[this.state.idKelas]} placeholder="Pilih Kelas..." />
                        <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={newProfil.idKelas} required />
                      </>
                    )}
                  </Fragment>
                </div>
              </Col>
              <Col sm={6}>
                <div className="form-group">
                  <Fragment>
                    {newProfil.idKelasGroup === null ? (
                      <>
                        <Select options={listKelasGroup} onChange={this.handleChangeSelect} placeholder="Pilih Kelas Group..." value="" />
                        <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value="" />
                      </>
                    ) : (
                      <>
                        <Select options={listKelasGroup} onChange={this.handleChangeSelect} defaultValue={listKelasGroup[this.state.idKelasGroup]} placeholder="Pilih Kelas Group..." />
                        <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={newProfil.idKelasGroup} required />
                      </>
                    )}
                  </Fragment>
                </div>
              </Col>
            </Row>
            {/* {newProfil.kodeTipeCbt === 'AGCU' || newProfil.kodeTipeCbt === 'PEMINATAN' &&
                            <Row>
                                <Col>
                                    <div className="form-group">
                                        <Fragment>  
                                            <Select 
                                                options={listAgcuNon}
                                                isMulti
                                                onChange={this.handleChangeSelect}
                                                placeholder ="Pilih Profil AGCU..."
                                            />
                                            <input
                                                tabIndex={-1}
                                                autoComplete="off"
                                                style={{ opacity: 0, height: 0 }}
                                                value={newProfil.idProfilAgcuNonAkademik}
                                                required
                                            />
                                        </Fragment>
                                    </div>       
                                </Col>
                            </Row>
                        } */}
            <Row>
              <Col>
                <button type="submit" value="Submit" className="btn btn-outline-primary pull-right">
                  <li className="fa fa-save"> {tipeButton}</li>
                </button>
              </Col>
            </Row>
          </form>
        </Modal.Body>
      </Modal>
    );
  }

  loadAlert = () => {
    const { alertShow, keterangan } = this.state;

    if (alertShow) {
      return (
        <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
          <strong>{keterangan}</strong>
        </Alert>
      );
    }
  };

  /* ================================= MGT LIST PROFIL ================================= */
  handleSetPoint = (profil, subprofil) => {
    history.push({
      pathname: "/sbmptn/soal/",
      state: { profil: profil, subProfil: subprofil },
    });
  };

  handleSubProfil = (profil, subprofil) => {
    history.push({
      pathname: "/cbt/mapel/",
      state: { profil: profil, subProfil: subprofil },
    });
  };

  handleProfilDialog = (data) => {
    this.setState({ isHapusProfil: true, isHapusMapel: false, hapusData: data });
  };

  handleSubProfilDialog = (data) => {
    this.setState({ isHapusProfil: false, isHapusMapel: true, hapusData: data });
  };

  handleDublicate = async (data) => {
    this.setState({ isOpenDublicat: true, profilSelected: data });
  };

  delete = async (id) => {
    this.setState({ isFetching: true });
    const { listProfil } = this.state;
    const json = { id: id };
    const resDelete = await accountManagement.post(CONFIG.EXAM_DELETE, json).catch(function (error) {
      alert(error);
    });

    console.log(resDelete.data);

    if (resDelete) {
      if (resDelete.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          isHapusProfil: false,
          alertShow: true,
          keterangan: resDelete.data.errorSchema.errorMessage,
          listProfil: listProfil.filter((profil) => profil.idProfilCbt !== id),
        });
      }
    }
    this.setState({ isFetching: false });
  };

  deleteSub = async (id) => {
    this.setState({ isFetching: true });
    const json = { id: id };
    const resDelete = await accountManagement.post(CONFIG.EXAM_DELETE_MAPEL, json).catch(function (error) {
      this.setState({ alertShow: true, resMessage: error });
    });

    if (resDelete) {
      if (resDelete.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          isHapusMapel: false,
          alertShow: true,
          keterangan: resDelete.data.errorSchema.errorMessage,
          listMapel: this.state.listMapel.filter((sub) => sub.idSubProfilCbt !== id),
        });
      }
    }
    this.setState({ isFetching: false });
  };

  confirmDialog() {
    const { hapusData, isHapusProfil, isHapusMapel } = this.state;
    const handleClose = () => {
      this.setState({ isHapusProfil: false, isHapusMapel: false });
    };
    let title, content, button;
    if (isHapusProfil) {
      title = "Hapus Profil ?";
      content = (
        <DialogContentText id="alert-dialog-description">
          Menghapus Profil juga akan menghapus Jadwal & report Siswa
          <br />
          Yakin akan menghapus Profil <strong>{hapusData.namaProfil}</strong> ?
        </DialogContentText>
      );
      button = (
        <button className="btn btn-primary" onClick={() => this.delete(hapusData.idProfilCbt)} autoFocus>
          {" "}
          Ya{" "}
        </button>
      );
    } else {
      title = "Hapus Mata Pelajaran ?";
      content = (
        <DialogContentText id="alert-dialog-description">
          Yakin akan menghapus Mata Pelajaran <strong>{hapusData.namaMapel}</strong> ?
        </DialogContentText>
      );
      button = (
        <button className="btn btn-success" onClick={() => this.deleteSub(hapusData.idSubProfilCbt)} autoFocus>
          {" "}
          Ya{" "}
        </button>
      );
    }
    return (
      <>
        <Dialog open={isHapusProfil ? isHapusProfil : isHapusMapel} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
          <DialogContent>{content}</DialogContent>
          <DialogActions>
            <button className="btn btn-danger" onClick={handleClose}>
              {" "}
              Tidak{" "}
            </button>
            {button}
          </DialogActions>
        </Dialog>
      </>
    );
  }

  renderListProfil() {
    return (
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell align="left">Nama Profil</TableCell>
              <TableCell align="left">Kode Sub</TableCell>
              <TableCell align="left">Kelas Group</TableCell>
              <TableCell align="right">#Aksi</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{this.renderRow()}</TableBody>
        </Table>
        <PaginationTable paging={this.state.paginationData} handleChangePage={this.handleChangePage} handleChangeRowsPerPage={this.handleChangeRowsPerPage} />
      </TableContainer>
    );
  }

  renderRow() {
    return (
      <React.Fragment>
        {this.state.listProfil.map((profil, i) => (
          <>
            <TableRow key={i}>
              <TableCell>
                <IconButton aria-label="expand row" size="small" onClick={() => this.setOpen(profil)}>
                  {profil.open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
              </TableCell>
              <TableCell align="left">{profil.namaProfil.split("~")[0]}</TableCell>
              <TableCell align="left">{profil.kodeSubTipeCbt}</TableCell>
              <TableCell align="left">{!__.isEmpty(profil.namaProfil.split("~")[1]) ? profil.namaProfil.split("~")[1] : profil.namaKelas}</TableCell>
              <TableCell align="right">
                {
                  <div className="button-group">
                    <button className="btn btn-outline-info btn-sm" title="Update Profil" onClick={() => this.changeMgtProfil(profil)}>
                      <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                    </button>
                    &nbsp;
                    <button className="btn btn-outline-danger btn-sm" title="Delete Profil" onClick={() => this.handleProfilDialog(profil)}>
                      <i className="fa fa-trash-o" aria-hidden="true"></i>
                    </button>
                    &nbsp;
                    {/* <button className="btn btn-outline-warning btn-sm" title="Dublicat Profil" onClick={() => this.handleDublicate(profil)}>
                      <i className="fa fa-copy" aria-hidden="true"></i>
                    </button> */}
                    <ModalDublicatProfil profil={profil} handleRefresh={this.handleRefresh} />
                  </div>
                }
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                <Collapse in={profil.open} timeout="auto" unmountOnExit>
                  <Box margin={1}>
                    <Typography variant="h6" gutterBottom component="div">
                      {
                        <button className="btn btn-outline-primary btn-sm" onClick={() => this.handleSubProfil(profil, {})}>
                          <i className="fa fa-plus" aria-hidden="true"></i> tambah Details
                        </button>
                      }
                    </Typography>

                    <Table size="small" aria-label="mapel">
                      <TableHead>
                        <TableRow>
                          <TableCell>Mata Pelajaran</TableCell>
                          <TableCell align="center">Soal</TableCell>
                          <TableCell align="center">Durasi</TableCell>
                          <TableCell align="center">KKM</TableCell>
                          <TableCell align="center">Random</TableCell>
                          <TableCell align="center">Nama Sub Kategori</TableCell>
                          <TableCell align="center"></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {!__.isEmpty(this.state.listMapel) &&
                          this.state.listMapel.map((val, i) => (
                            <TableRow>
                              <TableCell>{val.namaMapel}</TableCell>
                              <TableCell align="center">
                                {val.jumlahSoal}
                                {/*  <IconButton color="primary" size="small" title="preview soal..." component="span" onClick={() => this.handlePreviewSoal(profil, val)}>
                                                    <VisibilityRoundedIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton style={{color: '#dc3545'}} size="small" title="download soal..." component="span" onClick={() => this.handleDownloadSoal(profil, val)}>
                                                    <GetAppIcon fontSize="small" />
                                                </IconButton> */}
                              </TableCell>
                              <TableCell align="center">{val.durasi}</TableCell>
                              <TableCell align="center">{val.ketuntasanMinimum}</TableCell>
                              <TableCell align="center">
                                {val.random === 1 ? <i className="fa fa-check text-success" aria-hidden="true"></i> : <i className="fa fa-remove text-danger" aria-hidden="true"></i>}
                              </TableCell>
                              <TableCell align="center">{val.namaKategoriSubProfil}</TableCell>
                              <TableCell align="right">
                                <ButtonGroup variant="text" size="small" aria-label="text primary button group">
                                  <Button style={{ color: "#007bff" }} onClick={() => this.handleSetPoint(profil, val)}>
                                    set point
                                  </Button>
                                  <Button style={{ color: "#00a426" }} onClick={() => this.changeMgtSoal(true, profil, val)}>
                                    add soal
                                  </Button>
                                  <Button style={{ color: "#ffc107" }} onClick={() => this.handleSubProfil(profil, val)}>
                                    edit
                                  </Button>
                                  <Button style={{ color: "#dc3545" }} onClick={() => this.handleSubProfilDialog(val)}>
                                    hapus
                                  </Button>
                                  <Button onClick={() => this.handleDownloadSoal(profil, val)}>
                                    <GetAppIcon />
                                  </Button>
                                </ButtonGroup>
                              </TableCell>
                            </TableRow>
                          ))}

                        {this.state.nonAkademik.length > 0 && (
                          <>
                            {this.state.nonAkademik.map((item, i) => (
                              <TableRow key={i}>
                                <TableCell align="center" colSpan={6}>
                                  {item.namaProfilAgcu}
                                </TableCell>
                                <TableCell align="center">
                                  <Checkbox
                                    checked={item.idProfilCbt !== null}
                                    onChange={() => this.handleChangeNonAkademik(item, profil.idProfilCbt)}
                                    color="primary"
                                    inputProps={{ "aria-label": "secondary checkbox" }}
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                          </>
                        )}
                      </TableBody>
                    </Table>
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          </>
        ))}
      </React.Fragment>
    );
  }

  handleDownloadSoal = (profil, mapel) => {
    history.push({
      pathname: "/download-soal-too",
      state: { profil: profil, subProfil: mapel },
    });
  };

  handleOnChangeList = async (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const tipe = this.props.kodeTipeCbt;

    this.setState({
      [name]: value,
      isSearch: true,
    });

    // searchProfil
    if (name === "namaProfil") {
      this.setState({ listProfil: [] });
      this.fetchProfil(value);
    }

    if (name === "jumlahCari") {
      this.setState({ listProfil: [] });
      if (this.state.namaProfil != null) {
        const response = await akmApi
          .post(URL_AKM.PROFIL_SEARCH_NAME, {
            namaProfil: this.state.namaProfil,
            kodeTipeCbt: tipe,
            idKurikulum: value,
          })
          .catch(function (error) {
            this.setState({ error });
          });

        this.setState({ listProfil: response.data.data });
      }
    }
  };

  handleChangePage = async (newPage) => {
    this.state.paginationData.page = newPage;
    this.fetchProfil(this.state.namaProfil);
  };

  handleChangeRowsPerPage = (size) => {
    this.state.paginationData.page = 0;
    this.state.paginationData.size = size;
    this.fetchProfil(this.state.namaProfil);
  };

  fetchProfil = async (namaProfil) => {
    this.setState({ isSearch: true });
    const result = await akmApi.post(URL_AKM.PROFIL_LIST + "?page=" + this.state.paginationData.page + "&size=" + this.state.paginationData.size, {
      kodeSubTipeCbt: this.state.kodeSubTipeCbt,
      namaProfil: namaProfil,
    });
    if (result) {
      if (result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listProfil: result.data.data.content,
          paginationData: {
            ...this.state.paginationData,
            page: result.data.data.number,
            size: result.data.data.size,
            totalPages: result.data.data.totalPages,
            numberOfElements: result.data.data.numberOfElements,
            totalElements: result.data.data.totalElements,
          },
        });
      } else {
        this.setState({
          listSoal: [],
          paginationData: PaginationData,
          showAlert: true,
          resMessage: result.data.errorSchema.errorMessage,
        });
      }
      this.setState({ isSearch: false });
    }

    /*if(respProfilAgcu){
            if(respProfilAgcu.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    listProfil: respProfilAgcu.data.content,
                    paginationData: {...this.state.paginationData, 
                        page: respProfilAgcu.data.number,
                        size: respProfilAgcu.data.size,
                        totalPages: respProfilAgcu.data.totalPages,
                        numberOfElements: respProfilAgcu.data.numberOfElements,
                        totalElements: respProfilAgcu.data.totalElements
                    }
                })
            } else {
                this.setState({
                    listSoal: [],
                    paginationData:PaginationData,
                    showAlert: true,
                    resMessage: respProfilAgcu.data.errorSchema.errorMessage    
                })
            }
            this.setState({isFetching:false})
        } */
  };

  setOpen = async (profil) => {
    this.setState((state) => ({
      ...state,
      listProfil: this.state.listProfil.map((item) => (item.idProfilCbt === profil.idProfilCbt ? { ...item, open: !profil.open } : { ...item, open: false })),
    }));
    if (!profil.open) {
      this.setState({ isFetching: true, listMapel: [] });

      const response = await akmApi.get(URL_AKM.GET_SUBPROFIL_BY_IDPROFIL + profil.idProfilCbt).catch(function (error) {
        alert(error);
      });

      if (response) {
        if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
          this.setState({
            listMapel: response.data.data,
          });
        }
        this.setState({ isFetching: false });
      }
      console.log("profil ", profil)

      if (profil.kodeTipeCbt != "TOO" && profil.kodeTipeCbt != "ENSA") {
        this.fetchNonAkademik(profil.idProfilCbt)
      } else {
        this.fetchNonAkademikAkm(profil.idProfilCbt)
      }
    }
  };

  fetchNonAkademik = async (idProfilCbt) => {
    this.setState({ isFetching: true });
    const response = await akmApi.get(URL_AKM.GET_PROFIL_NON_AKADEMIK_AGCU + idProfilCbt).catch(function (error) {
      alert(error);
    });

    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          nonAkademik: response.data.data,
        });
      } else {
        this.setState({ nonAkademik: [] });
      }
      this.setState({ isFetching: false });
    }
  };

  fetchNonAkademikAkm = async (idProfilCbt) => {
    this.setState({ isFetching: true });
    const response = await akmApi.get(URL_AKM.GET_PROFIL_NON_AKADEMIK_AKM + idProfilCbt).catch(function (error) {
      alert(error);
    });

    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          nonAkademik: response.data.data,
        });
      } else {
        this.setState({ nonAkademik: [] });
      }
      this.setState({ isFetching: false });
    }
  };

  handleChangeNonAkademik = async (data, idProfilCbt) => {
    this.setState({ isFetching: true });
    const response = await akmApi.post(URL_AKM.POST_PROFIL_NON_AKADEMIK_AKM, { ...data, idProfilCbt: idProfilCbt }).catch(function (error) {
      alert(error);
    });
    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        let nonAkademik = [...this.state.nonAkademik];
        nonAkademik.map((item) => {
          if (item.idProfilAgcuNonAkademik === data.idProfilAgcuNonAkademik) {
            item.idProfilCbt = response.data.data.idProfilCbt;
            item.idProfilCbtAgcuHub = response.data.data.idProfilCbtAgcuHub;
          }
        });

        this.setState({ nonAkademik: nonAkademik });
      } else {
        this.setState({
          alertShow: true,
          resMessage: response.data.errorSchema.errorMessage,
        });
      }
    }

    this.setState({ isFetching: false });
  };
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps, { cekCookies })(MgtProfil);
